import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import VendingMachinesDataGrid from "./VendingMachinesDataGrid";
import { getCurrentTenant } from "../../config/tenantConfig";


export default function MainGridNodeDetail() {
  const currentTenant = getCurrentTenant();
  console.log("Current Tenant:", currentTenant);

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 12 }}>
            <VendingMachinesDataGrid />
        </Grid>
      </Grid>
    </Box>
  );
}
